import { FileSpreadsheet, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { exportToExcel, exportToPDF } from '@/lib/export-utils';

type Props = {
  columns: { header: string; key: string }[];
  rows: Record<string, any>[];
  fileName: string;
  title?: string;
};

export function ExportButtons({ columns, rows, fileName, title }: Props) {
  const disabled = rows.length === 0;
  const mapped = rows.map((r) =>
    Object.fromEntries(columns.map((c) => [c.header, r[c.key] ?? ''])),
  );

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={() => exportToExcel(mapped, fileName, title ?? fileName)}
      >
        <FileSpreadsheet size={14} className="mr-1" /> Excel
      </Button>
      <Button
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={() => exportToPDF(columns, rows, fileName, title)}
      >
        <FileText size={14} className="mr-1" /> PDF
      </Button>
    </div>
  );
}
